import React from 'react'

function PrintAble({ children }) {
    return (
        <div className='printArea' id='printAble'>
            <link rel="stylesheet" href="/print.css" />
            {children}
        </div>
    )
}

export default PrintAble